import React from 'react'
import styles from './RichListItem.scss'
import { Icon } from 'common/Icon'
import cx from 'classnames'

export class RichListItem extends React.PureComponent {
  render () {
    const { title, children, footer, left, right, hoverable } = this.props
    return (
      <div className={cx(styles.RichListItem, hoverable && styles.hoverable)}>
        {left && <div className={styles.left}>{left}</div>}
        <div className={styles.main}>
          <h3>{title}</h3>
          <div className={styles.details}>
            {children}
          </div>
          {footer && <div className={styles.footer}>
            {footer}
          </div>}
        </div>
        {right && <div className={styles.right}>{right}</div>}
      </div>
    )
  }
}

export const RichListItemDetail = ({ wide, className, tip, children, icon, iconColor, hoverable, ...props }) => (
  <div className={cx(styles.RichListItemDetail, wide && styles.wide, hoverable && styles.hoverableDetail, className)} {...props}>
    {icon && <Icon i={icon} title={tip} data-tip={tip ? 'true' : null} style={{ color: iconColor }} className={styles.icon} />}
    {children}
  </div>
)

export const RichListItemBadge = ({ bg, color, outline, ...props }) => {
  const style = outline
    ? {
      border: `1px solid ${bg}`,
      color: bg
    }
    : {
      color,
      background: bg
    }
  return <span {...props} style={style} className={styles.RichListItemBadge} />
}
